import {post} from './RequestUtil'
import vue from '../main'

export const CategoryRequestUtil = {
  queryCategoryList (params, callback) {
    post('/category/list', params).then((response) => {
      callback && callback(response)
    })
  },
  updateSort (params, callback) {
    post('/category/sort', params).then((response) => {
      callback && callback(response)
    })
  },
  remove (params, callback) {
    post('/category/remove', params).then((response) => {
      response.result && vue.$message.success('操作成功')
      callback && callback(response)
    })
  },
  save (params, callback) {
    post('/category/save', params).then((response) => {
      callback && callback(response)
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/CategoryRequestUtil.js